import { usePublicMapSettingsIsZoomEnabledSelector } from '~/store/mapSettings/publicMapSettings/mapSettingsPublicMapSettings.selectors';
import {
  useIsMapOverlayUiHidden, useIsMapPresentationalSelector,
} from '~/store/selectors/useMapInfoSelectors';
import { getZoomControlsVisible } from './zoomControls.helpers';

export const useZoomControlsVisible = () => {
  const isMapPresentational = useIsMapPresentationalSelector();
  const isZoomEnabledInPublicSettings = usePublicMapSettingsIsZoomEnabledSelector();
  const isMapOverlayUiHidden = useIsMapOverlayUiHidden();

  return !isMapOverlayUiHidden && getZoomControlsVisible(isMapPresentational, isZoomEnabledInPublicSettings);
};
